import { IMenuCategory } from '../../Store/IMenuCategory'

export const isPersonSelectableCheck = (menuArray: IMenuCategory) =>
  menuArray.activities.some(
    (activity) => activity.isPersonSelectable === true
  )
